import React from 'react'
import { connect } from 'react-redux'
import { getBranches, getBranchesPaginated } from '../../api/branchapi'
import { getPermission } from '../../api/userapi'
import SearchBar from '../SearchBar'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { handleDropDownClick } from '../../helpers'
import { updateRedirect } from './../../helpers/redirect'
import ReportTypes from '../reports/reportTypes'
import '../css/View.css'

import DataTableBase from '../utils/DataTable';

class BranchView extends React.Component {
    constructor(props) {
        super(props)
        this.permission = getPermission()
        let filterValue = ''
        if (this.props.route.location.state) filterValue = this.props.route.location.state.branchFilter
        this.table = React.createRef()
        this.state = {
            data: [],
            expanded: {},
            branch: {},
            loading: true,
            onlyActive: false,
            customFilters: {
                showOnlyActiveFilter: true,
                onlyActiveFilterLabel: "Only show active branches",
                onlyActiveOnChange: this.onlyActiveOnChange
            },
            value: filterValue,
            edit: false,
            create: false,
            dropdownOpen: false,
            branchAmount: 0,
            moreOptions: [],
            openStyle: false,
            searches: false,
            clubFilter: {},
            route: '',
            selected: '',
            redirectToReport: false,
            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.isSorting = false;
        this.onlyActiveOnChange = this.onlyActiveOnChange.bind(this);
        this.filterSearch = this.filterSearch.bind(this)
        this.handleEdit = this.handleEdit.bind(this)
        this.handleCreate = this.handleCreate.bind(this)
        this.fetchData = this.fetchData.bind(this)
        this.handleEdit = this.handleEdit.bind(this)
        this.handleCreate = this.handleCreate.bind(this)
        this.toggle = this.toggle.bind(this)
        this.redirectDropdown = this.redirectDropdown.bind(this)
        this.stateSettingClosed = this.stateSettingClosed.bind(this)
        this.stateSettingOpened = this.stateSettingOpened.bind(this)
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleSort = this.handleSort.bind(this)
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen,
        }))
    }

    //Checks if we were redirected from another component and have props with filters
    componentDidMount() {
        this.setState({
            loading: true,
        })
        if (this.props.route.location.state) {
            this.props.getBranches(
                function (result, _this) {
                    _this.getData(result, _this)
                },
                this,
                this.state.value
            )
        } else {
            this.fetchData('', 0, false);
        }
    }

    redirectDropdown(item, name) {
        switch (item) {
            case 'Products':
                var route = (
                    <Redirect
                        to={{
                            pathname: `/secure/products`,
                            state: { productFilter: name, from: 'branches' },
                        }}
                    />
                )
                break

            case 'Cities':
                var route = (
                    <Redirect
                        to={{
                            pathname: `/secure/locations`,
                            state: { locationFilter: name, from: 'branches' },
                        }}
                    />
                )
                break
        }

        this.setState({
            dropdownClicked: true,
            branchFilter: name,
            route: route,
            selected: item,
        })
    }

    handleEdit(branch) {
        this.setState({
            edit: true,
            branch: branch,
        })
    }

    onlyActiveOnChange = (e) => {
        var value = this.state.value;
        var isChecked = e.target.checked;
        if (isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        } else if (!isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    handleCreate() {
        this.setState({
            create: true,
        })
    }

    //Redirects to the clubView when clubName is clicked on the table
    handleRedirectClub(club) {
        let clubFilter = { clubId: club.clubId }
        this.setState({
            clubFilter: clubFilter,
            redirectClub: true,
        })
    }

    //Parent setting state to pass as props to child function for dropdown
    stateSettingClosed(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
            openStyle: false,
        })
    }

    //Parent setting state to pass as props to child function for dropdown
    stateSettingOpened(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
            openStyle: true,
        })
    }

    filterSearch(event) {
        var value = event.target.value
        var isChecked = this.state.onlyActive;
        if (event.key === 'Enter' && value) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                page: 0,
                loading: true,
                value: value,
            })
        } else if (!value) {
            this.fetchData(value, 0, isChecked)
            this.setState({
                page: 0,
                loading: true,
                value: value,
            })
        }
    }

    fetchData(filterValue, page, isChecked) {
        var p = (
            <p className="cursor closed">
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>
        )
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined) {
            page = this.state.defaultPage;
        }
        if (page !== 0)
            page = page - 1;
        if (isChecked === undefined)
            isChecked = this.state.onlyActive;
        this.setState({ loading: true, error: false })
        let orderBy = this.state.orderBy;
        let descending = this.state.descending;
        getBranchesPaginated(filterValue, page, this.state.perPage, orderBy, descending, isChecked)
            .then(res => {
                var moreOptions = []
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    page: res.data.data.currentPage,
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    moreOptions: moreOptions,
                    loading: false,
                    totalRows: res.data.data.rowCount
                })
            })
            .catch(err => {
                var errorList = []
                err.response.data.errors.map(function (e) {
                    errorList.push(e.message)
                })

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    onlyActive: false,
                    errorMessage: errorList,
                })
            })
    }

    getData(data, _this) {
        var length = data.data.data.length
        var p = (
            <p className="cursor closed">
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>
        )
        var moreOptions = []
        for (let x = 0; x < length; x++) {
            moreOptions.push(p)
        }

        console.log(data)
        _this.setState({
            branches: data.data.data,
            data: data.data.data,
            moreOptions: moreOptions,
            loading: false,
            // pageCount: data.data.data.pageCount,
            // pageSize: data.data.data.pageSize,
        })
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page, this.state.isChecked);
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page, this.state.isChecked);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value);
            this.isSorting = false;
        });
    }

    isInvalid(e) {
        var input = e.target
        if (input.value) {
            input.classList.remove('is-invalid')
        } else {
            input.classList.add('is-invalid')
        }
    }

    render() {
        ///All variables and constants for rendering///

        //This style will make the clubcode border-right dissapear for dropdown UX consistency
        var style = this.state.openStyle
            ? { textAlign: 'left', borderRight: 'none' }
            : { textAlign: 'left' }

        //List of items to pass to the dropdown as <a>
        let items = ['Cities', 'Products']

        //Name of component to pass to the dropdown to indentify dropdown className
        var component = 'branches'

        if (this.state.redirectToReport)
            return <Redirect to={{ pathname: '/secure/gift/report', state: { report: ReportTypes.SalesReport } }} push={true} />

        if (this.state.edit) {
            return (
                <Redirect
                    to={{
                        pathname: `/secure/branchEdit/${this.state.branch.branchId}`,
                        state: { branch: this.state.branch, from: 'view' },
                    }}
                />
            )
        }

        if (this.state.create) {
            return (
                <Redirect
                    to={{
                        pathname: `/secure/branchCreate`,
                    }}
                />
            )
        }

        if (this.state.dropdownClicked) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: this.state.selected.toLowerCase(),
                selectedAdmin: '',
                toggleAdminDropdown: false,
            })

            return this.state.route
        }

        if (this.state.redirectClub) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: 'admin',
                selectedAdmin: 'clubs',
                toggleAdminDropdown: true,
            })
            return (
                <Redirect
                    to={{
                        pathname: `/secure/clubEdit/${this.state.clubFilter.clubId}`,
                        state: { clubFilter: this.state.clubFilter, from: 'branches' },
                    }}
                />
            )
        }

        const columns = [
            {
                //Branch Name header
                name:
                    <div
                        style={{
                            textAlign: 'left',
                            textIndent: 10,
                        }}
                    >
                        Branch <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '400px',
                selector: row => row.name,
                sortable: true,
                sortField: 'name',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p style={{ marginLeft: '10px' }} className="cursor">
                            {row.name}
                        </p>
                    </div>
                ),
            },
            {
                //Branch code header
                name:
                    <div
                        style={{
                            textAlign: 'left',
                        }}
                    >
                        Branch code <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                selector: row => row.branchCode,
                sortable: true,
                sortField: 'branchCode',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p className="cursor">{row.branchCode}</p>
                    </div>
                ),
            },
            {
                //club name header
                name:
                    <div
                        style={{
                            textAlign: 'left',
                        }}
                    >
                        Club <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '400px',
                selector: row => row.clubName,
                sortable: true,
                sortField: 'clubName',
                cell: row => (
                    <div
                        onClick={() => {
                            if (!this.permission.isAdmin) {
                                return
                            }
                            this.handleRedirectClub(row)
                        }}
                    >
                        <p style={{ marginLeft: '5px' }} className="cursor">
                            {row.clubName}
                        </p>
                    </div>
                ),
            },
            {
                //options header
                name:
                    <div
                        style={{
                            textAlign: 'center',
                        }}
                    >
                        Options
                    </div>,
                center: true,
                style: { justifyContent: 'center' },
                width: '100px',
                //options row
                cell: (row, index, column) => (
                    <div
                        onClick={ev =>
                            handleDropDownClick(
                                ev,
                                index,
                                this.state.moreOptions,
                                this.stateSettingClosed,
                                this.stateSettingOpened,
                                items,
                                component,
                                this.redirectDropdown,
                                row.name
                            )
                        }
                    >
                        {this.state.moreOptions[index]}
                    </div>
                ),
            },
        ]
        return (
            <div>
                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                    value={this.state.value}
                    customFilters={this.state.customFilters}
                />
                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />
                {this.permission.isAdmin &&
                    <button onClick={() => this.handleCreate()} className="btn mt-4">
                        {' '}
                        + BRANCH
                    </button>}
                <button onClick={() => this.setState({ redirectToReport: true })} className="btn mt-4 ml-2">Reports</button>
            </div>
        )
    }
}

export default connect(
    state => {
        return {
            branches: state.data.branches,
        }
    },
    dispatch => ({
        getBranches: (callback, conext, filter) => {
            dispatch(getBranches(callback, conext, filter))
        },
        currentNavigationConnect: response => {
            dispatch(updateRedirect(response))
        },
    })
)(BranchView)
